import colors from 'components/core/colors';

export default function welcomeDoormat() {
  console.log(
    `%c
                                                      
  MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM  
  MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM  
  MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM  
  MMMMMMMMMMMMMMMMMMMMMMWWWWWWMMMMMMMMMMMMMMMMMMMMMM  
  MMMMMMMMMMMMMMMMMN0xoc:;;;;::lx0XWXxxXMMMMMMMMMMMM  
  MMMMMMMMMMMMMMW0o;...:lllllll:'.':,..kMMMMMMMMMMMM  
  MMMMMMMMMMMMWKo.  ,dKWMMMMMMMWXx,   .kMMMMMMMMMMMM  
  MMMMMMMMMMMWk,   :KMMMMMMMMMMMMMK:. .kMMMMMMMMMMMM  
  MMMMMMMMMMWk'   :KMMMMMMMMMMMMMMM0, .kMMMMMMMMMMMM  
  MMMMMMMMMMO,   'OMMMMMMMMMMMMMMMMWo..kMMMMMMMMMMMM  
  MMMMMMMMMXc    cNMMMMMMMMMMMMMMMMMKddKMMMMMMMMMMMM  
  MMMMMMMMMO'   .dWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM  
  MMMMMMMMWd.   .kMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM  
  MMMMMMMMWo.   .OMMMMMMWO.llllllllllllllkNMMMMMMMMM  
  MMMMMMMMNl.   .OMMMMMMWOo.lllc;.     .:kNMMMMMMMMM  
  MMMMMMMMWd.   .kMMMMMMMMMMMMMMWO.   .oWMMMMMMMMMMM  
  MMMMMMMMMk.   .dWMMMMMMMMMMMMMMN.   .kMMMMMMMMMMMM  
  MMMMMMMMMK:    cXMMMMMMMMMMMMMMN.   .OMMMMMMMMMMMM  
  MMMMMMMMMWx.   'kMMMMMMMMMMMMMMN.   .OMMMMMMMMMMMM  
  MMMMMMMMMMNo.   :KMMMMMMMMMMMMMN.   .OMMMMMMMMMMMM  
  MMMMMMMMMMMNd.  .:KWMMMMMMMMMMMK.   .OMMMMMMMMMMMM  
  MMMMMMMMMMMMWO:.  'dKWMMMMMMMNO;.'. .OMMMMMMMMMMMM  
  MMMMMMMMMMMMMMNOl'...:WMMMMMW;',xKc .OMMMMMMMMMMMM  
  MMMMMMMMMMMMMMMMWNOxoc:;;;;:coOXMMKodXMMMMMMMMMMMM  
  MMMMMMMMMMMMMMMMMMMMMMWWWNWWMMMMMMMMMMMMMMMMMMMMMM  
  MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM  
  MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM  
  MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM  
                                                      
                  gallery.so/careers                  
                                                      
`,
    `background: ${colors.offBlack}; color: ${colors.offWhite}`
  );
}
